import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    olddata:{}
    
}
const mutations={
   
    getLogisticsIndex(state,value){
        
        
       
        post(urls.admin.logistics.index,value).then((result)=>{
          
          
          
          state.result=result


        
       
           
        });
        
    },
    editLogistics(state,value){



        post(urls.admin.logistics.edit,value).then((result)=>{



            state.result=result




        });

    },
    addLogistics(state,value){



        post(urls.admin.logistics.add,value).then((result)=>{



            state.result=result




        });

    },

    deleteLogistics(state,value){



        post(urls.admin.logistics.delete,value).then((result)=>{



            state.result=result




        });

    },

  

 

}
const  actions={


    getLogisticsIndexAction(context,value){
       
        context.commit("getLogisticsIndex",value)
       
    },
    editLogisticsAction(context,value){

        context.commit("editLogistics",value)

    },
    addLogisticsAction(context,value){

        context.commit("addLogistics",value)

    },
    deleteLogisticsAction(context,value){

        context.commit("deleteLogistics",value)

    },
  
  

    

}

export default {state,mutations,actions}